import { VerticalSpace } from '@brokerbay/design-components';
import axios from 'axios';
import {
  Button,
  Checkbox,
  Input,
  message,
  Page,
  Text,
  Select,
} from 'components';
import { AuthContext } from 'contexts';
import React from 'react';
import styled from 'styled-components';
import ExpireListings from './ListingCronJobs/ExpireListings';

enum CronNames {
  EXPIRE_LISTINGS = 'expireListings',
}

const getC = (
  c: `${CronNames}`,
): React.FC<{ fire: (payload: any) => Promise<void> }> => {
  switch (c) {
    case 'expireListings':
      return ExpireListings;

    default:
      return ExpireListings;
  }
};

const ListingCronJobs = () => {
  const [cronType, setCronType] =
    React.useState<`${CronNames}`>('expireListings');
  const [isLoading, setIsLoading] = React.useState(false);

  const fire = async (payload: any) => {
    try {
      if (isLoading) return;
      setIsLoading(true);
      const response = await axios.post(`/listing/qa_page/${cronType}`, {
        data: payload,
      });
      if (response.data?.message) {
        message.success(response.data.message);
      } else {
        message.success(`Cron job: ${cronType} was triggered`);
      }
    } catch (error) {
      message.error(error?.toString(), 8);
    } finally {
      setIsLoading(false);
    }
  };

  const Form = getC(cronType);

  return (
    <Page type="filled" title="Listing Cronjobs QA Page" fillScreenHeight>
      <Layout>
        <Text>
          This QA page is used to manually fire cron jobs related to listings
        </Text>
        <StyledSelect
          value={cronType}
          onChange={value => setCronType(value)}
          options={Object.values(CronNames).map(v => ({
            label: v,
            value: v,
          }))}
          label="Cron Name"
        />
        <Form fire={fire} />
      </Layout>
    </Page>
  );
};

export default ListingCronJobs;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  padding: 20px;
  background: white;
`;

const StyledSelect = styled(Select)`
  width: 500px;
`;

const StyledText = styled(Text)`
  line-height: 2;
`;
